const STORAGE_KEY = 'admin-whats-new'

const emptyState = () => ({ seenSlugs: [], hintDismissed: false })

const readWhatsNewState = () => {
  if (typeof localStorage === 'undefined') return emptyState()
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '')
    return {
      seenSlugs: Array.isArray(parsed?.seenSlugs) ? parsed.seenSlugs : [],
      hintDismissed: Boolean(parsed?.hintDismissed),
    }
  } catch {
    return emptyState()
  }
}

const writeWhatsNewState = (state) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  return state
}

const markSlugsSeen = (slugs) => {
  const current = readWhatsNewState()
  const seenSlugs = Array.from(new Set([...current.seenSlugs, ...slugs]))
  return writeWhatsNewState({ ...current, seenSlugs })
}

const dismissHint = () => {
  const current = readWhatsNewState()
  return writeWhatsNewState({ ...current, hintDismissed: true })
}

const unseenTourFeatures = (features, seenSlugs) => {
  const seen = new Set(seenSlugs || [])
  return (features || []).filter(
    (feature) => feature.includeInTour !== false && !seen.has(feature.slug)
  )
}

export { dismissHint, markSlugsSeen, readWhatsNewState, unseenTourFeatures }
